export const LODS = [
        {
            level: 0,
            resolution: 156543.033928,
            scale: 591657527.591555
        },
        {
            level: 1,
            resolution: 78271.5169639999,
            scale: 295828763.795777
        },
        {
            level: 2,
            resolution: 39135.7584820001,
            scale: 147914381.897889
        },
        {
            level: 3,
            resolution: 19567.8792409999,
            scale: 73957190.948944
        },
        {
            level: 4,
            resolution: 9783.93962049996,
            scale: 36978595.474472
        },
        {
            level: 5,
            resolution: 4891.96981024998,
            scale: 18489297.737236
        },
        {
            level: 6,
            resolution: 2445.98490512499,
            scale: 9244648.868618
        },
        {
            level: 7,
            resolution: 1222.99245256249,
            scale: 4622324.434309
        },
        {
            level: 8,
            resolution: 611.49622628138,
            scale: 2311162.217155
        },
        {
            level: 9,
            resolution: 305.748113140558,
            scale: 1155581.108577
        },
        {
            level: 10,
            resolution: 152.874056570411,
            scale: 577790.554289
        },
        {
            level: 11,
            resolution: 76.4370282850732,
            scale: 288895.277144
        },
        {
            level: 12,
            resolution: 38.2185141425366,
            scale: 144447.638572
        },
        {
            level: 13,
            resolution: 19.1092570712683,
            scale: 72223.819286
        },
        {
            level: 14,
            resolution: 9.55462853563415,
            scale: 36111.909643
        },
        {
            level: 15,
            resolution: 4.77731426794937,
            scale: 18055.954822
        },
        {
            level: 16,
            resolution: 2.38865713397468,
            scale: 9027.977411
        },
        {
            level: 17,
            resolution: 1.19432856685505,
            scale: 4513.988705
        },
        {
            level: 18,
            resolution: 0.597164283559817,
            scale: 2256.994353
        },
        {
            level: 19,
            resolution: 0.298582141647617,
            scale: 1128.497176
        },
        {
            level: 20,
            resolution: 0.1492910708238085,
            scale: 564.248587
        },
        {
            level: 21,                      // Here down each level is .85 of the last
            resolution: 0.1268974102002370,
            scale: 479.6112990
        },
        {
            level: 22,
            resolution: 0.1078627986702010,
            scale: 407.6696041
        },
        {
            level: 23,
            resolution: 0.0916833788696711,
            scale: 346.5191635
        },
/*        {
            level: 24,
            resolution: 0.0779308720392204,
            scale: 294.5412890
        },*/
        {
            level: 24, // This one matches a basemap set
            resolution: 0.0746455354119043,
            scale: 282.1242935
        },
        {
            level: 25,
            resolution: 0.0662412412333373,
            scale: 250.3600956
        },
        {
            level: 26,
            resolution: 0.0563050550483367,
            scale: 212.8060813
        },
        {
            level: 27,
            resolution: 0.0478592967910862,
            scale: 180.8851691
        },
        {
            level: 28,
            resolution: 0.0406804022724233,
            scale: 153.7523937
        },
        {
            level: 29,
            resolution: 0.0345783419315598,
            scale: 130.6895347
        },
        {
            level: 30,
            resolution: 0.0293915906418258,
            scale: 111.0861045
        },
        {
            level: 31,
            resolution: 0.0249828520455520,
            scale: 94.4231888
        },
        {
            level: 32,
            resolution: 0.0212354242387192,
            scale: 80.2597105
        },
        {
            level: 33,
            resolution: 0.0180501106029113,
            scale: 68.2207539
        },
      ]